import { createSlice } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    companies: [],
    companyId: null,
    companyName: "",
    companyLogo: "",
    customersWeb: [],
    companyIds: [],
    locations: [],
    people: [],
    account: {},
    orders: {},
    productData: null,
    customersWeb: []
  },
  reducers: {
    setCompanies(state, action) {
      state.companies = action.payload;
    },
    setCompanyId(state, action) {
      state.companyId = action.payload;
    },
    setCompany(state, action) {
      state.companyId = action.payload;

      //reset the orders data when changing company
      state.orders = {};

      let customerWeb = state.customersWeb.find(
        (customer) => customer.id === action.payload
      );
      let company = state.companyIds.find(
        (company) => company.id === action.payload
      );
      if (company) {
        state.people = company.OnSite;
      }
    },
    setCustomersWeb(state, action) {
      state.customersWeb = action.payload;
    },
    setCompanyIds(state, action) {
      state.companyIds = action.payload;
    },
    setLocations(state, action) {
      state.locations = action.payload;
    },
    setAccount(state, action) {
      state.account = action.payload;
    },
    setOrders(state, action) {
      state.orders = action.payload;
    },
    setProductData(state, action) {
      state.productData = action.payload;
    },
    setLoginStatus(state, action) {
      state.login = action.payload;
    },
    
    setUserDetails(state, action) {
      const {
        companyId,
        companyName,
        locations,
        companyLogoURL,
        Carrier_Organised_By_Default,
        Delivery_Point_Default,
        Flag_CreditHold,
        viewOnly,
        canExport,
        peopleOnsite
      } = action.payload;
      state.companyId = companyId;
      state.companyName = companyName;
      state.locations = locations;
      state.account.companyLogoURL = companyLogoURL;
      state.account.Carrier_Organised_By_Default = Carrier_Organised_By_Default;
      state.account.Delivery_Point_Default = Delivery_Point_Default;
      state.account.Flag_CreditHold = Flag_CreditHold;
      state.Flag_CreditHold = Flag_CreditHold;
      state.account.viewOnly = viewOnly;
      state.account.canExport = canExport;
      state.account.peopleOnsite = peopleOnsite;
    },
    
    //set multiple user details at once to avoid multiple re-renders
    setAllUserDetails(state, action) {
      const {
        account,
        productData,
        companyId,
        companyIds,
        locations,
        customersWeb,
        people,
        Flag_CreditHold,
        canExport,
        viewOnly
      } = action.payload;
      state.account = account;
      state.productData = productData;
      state.companyId = companyId;
      state.companyIds = companyIds;
      state.locations = locations;
      state.customersWeb = customersWeb;
      state.people = people;
      state.Flag_CreditHold = Flag_CreditHold;
      state.account.viewOnly = viewOnly;
      state.account.canExport = canExport;
    },

    resetState(state) {
      state.companyId = null;
      state.companyName = null;
      state.locations = [];
      state.people = [];
      state.companyIds = [];
      state.customersWeb = [];
      state.account = {};
      state.orders = {};
      state.productData = null;
      state.viewOnly = null;
      state.canExport = null;
      state.Flag_CreditHold = false;
    },
  },
});

export const {
  setCompanies,
  setCompanyId,
  setCompany,
  setCustomersWeb,
  setCompanyIds,
  setLocations,
  setPeople,
  setLoggedIn,
  setAccount,
  setOrders,
  setProductData,
  setAllUserDetails,
  setUserDetails,
  resetState,
} = appSlice.actions;
export default appSlice.reducer;